import { getMarketRates } from './PricingWebAPIUtils';
export const useGetMarketShipperRates = async (marketId, limit, offset) => {
    var _a;
    const ratesRes = await getMarketRates(marketId, limit, offset);
    const rates = (ratesRes === null || ratesRes === void 0 ? void 0 : ratesRes.data) || [];
    return {
        rates,
        total: ((_a = ratesRes === null || ratesRes === void 0 ? void 0 : ratesRes.data) === null || _a === void 0 ? void 0 : _a.count) || 0,
    };
};
